module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    class: {
      '-fixed-height-box': _vm.pcDisp
    },
    attrs: {
      "id": "pers-tab5",
      "name": "hres31x-tab5"
    }
  }, [_c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-btc icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['10']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['numtaxid']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['numsaid']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['tax_deduct']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.detail['frsmemb'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['tax_payment']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['codcln']))])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic2
    }
  }, [_c('i', {
    staticClass: "fa fa-university icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['90']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic2),
      expression: "subTopic2"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['codbank1']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['numbank']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['amtbank']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['codbank2']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P1']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['numbank2']))])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic3
    }
  }, [_c('i', {
    staticClass: "fa fa-btc icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['10']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic3),
      expression: "subTopic3"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.detail['dtebf'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['amtincbf']) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['amttaxbf']) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['amtpf']) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['amtsaid']) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']))])]), _vm._v(" "), _c('div', {
    staticClass: "lv2-sub-topic-box"
  }, [_c('div', {
    staticClass: "lv2-sub-topic color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['80']))])]), _vm._v(" "), _c('div', {
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.detail['dtebfsp'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['amtincsp']) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['amttaxsp']) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['amtpfsp']) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['amtsasp']) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']))])])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box editor-row"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.detail['dteupd'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box editor-row"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P2']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail.detail['coduser']))])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic4
    }
  }, [_c('i', {
    staticClass: "fa fa-btc icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P3']['10']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic4),
      expression: "subTopic4"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "tax-table-box clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 tax-table-heading-left bg-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P3']['20']) + " - " + _vm._s(_vm.labels['HRES31C5P3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 tax-table-heading-right bg-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 tax-table-heading-right bg-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P3']['50']))])]), _vm._v(" "), _vm._l((_vm.detail.tableTaxExemption.rows), function(value, index) {
    return [_c('div', {
      staticClass: "tax-table-box clearfix",
      class: {
        'even': index % 2 == 0
      }
    }, [_c('div', {
      staticClass: "col-xs-12 tax-table-body-left color-skin"
    }, [_vm._v(_vm._s(value.coddeduct) + " - " + _vm._s(value.desc_coddeduct))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 tax-table-body-right"
    }, [_vm._v("\n          " + _vm._s(_vm.labels['HRES31C5P3']['40']) + "   " + _vm._s(value.v_amtdeduct) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 tax-table-body-right"
    }, [_vm._v("\n          " + _vm._s(_vm.labels['HRES31C5P3']['50']) + "   " + _vm._s(value.v_amtspded) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']) + "\n        ")])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic5
    }
  }, [_c('i', {
    staticClass: "fa fa-btc icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P4']['10']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic5),
      expression: "subTopic5"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "tax-table-box clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 tax-table-heading-left bg-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P4']['20']) + " - " + _vm._s(_vm.labels['HRES31C5P4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 tax-table-heading-right bg-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 tax-table-heading-right bg-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P4']['50']))])]), _vm._v(" "), _vm._l((_vm.detail.tableTaxDeduction.rows), function(value, index) {
    return [_c('div', {
      staticClass: "tax-table-box clearfix",
      class: {
        'even': index % 2 == 0
      }
    }, [_c('div', {
      staticClass: "col-xs-12 tax-table-body-left color-skin"
    }, [_vm._v(_vm._s(value.coddeduct) + " - " + _vm._s(value.desc_coddeduct))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 tax-table-body-right"
    }, [_vm._v("\n          " + _vm._s(_vm.labels['HRES31C5P4']['40']) + "   " + _vm._s(value.v_amtdeduct) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 tax-table-body-right"
    }, [_vm._v("\n          " + _vm._s(_vm.labels['HRES31C5P4']['50']) + "   " + _vm._s(value.v_amtspded) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']) + "\n        ")])]), _vm._v(" "), (index == _vm.detail.tableTaxDeduction.rows.length - 1) ? [_c('div', {
      staticClass: "row data-box editor-row"
    }, [_c('div', {
      staticClass: "col-xs-8 data-label color-skin"
    }, [_vm._v(_vm._s(_vm.labels['HRES31C5P4']['60']))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 data-text"
    }, [_vm._v("\n            " + _vm._s(value.qtychedu) + "   " + _vm._s(_vm.labels['HRES31C5P4']['70']) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "row data-box editor-row"
    }, [_c('div', {
      staticClass: "col-xs-8 data-label color-skin"
    }, [_vm._v(_vm._s(_vm.labels['HRES31C5P4']['80']))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 data-text"
    }, [_vm._v("\n            " + _vm._s(value.qtychned) + "   " + _vm._s(_vm.labels['HRES31C5P4']['90']) + "\n          ")])])] : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic6
    }
  }, [_c('i', {
    staticClass: "fa fa-btc icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P5']['10']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic6),
      expression: "subTopic6"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "tax-table-box clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 tax-table-heading-left bg-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P5']['20']) + " - " + _vm._s(_vm.labels['HRES31C5P5']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 tax-table-heading-right bg-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P5']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 tax-table-heading-right bg-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES31C5P5']['50']))])]), _vm._v(" "), _vm._l((_vm.detail.tableOtherDeduction.rows), function(value, index) {
    return [_c('div', {
      staticClass: "tax-table-box clearfix",
      class: {
        'even': index % 2 == 0
      }
    }, [_c('div', {
      staticClass: "col-xs-12 tax-table-body-left color-skin"
    }, [_vm._v(_vm._s(value.coddeduct) + " - " + _vm._s(value.desc_coddeduct))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 tax-table-body-right"
    }, [_vm._v("\n          " + _vm._s(_vm.labels['HRES31C5P5']['40']) + "   " + _vm._s(value.v_amtdeduct) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 tax-table-body-right"
    }, [_vm._v("\n          " + _vm._s(_vm.labels['HRES31C5P5']['50']) + "   " + _vm._s(value.v_amtspded) + "   " + _vm._s(_vm.labels['HRES31XC1']['270']) + "\n        ")])])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71d0b878!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/tab5.vue
// module id = 3860
// module chunks = 1